module.exports = __webpack_public_path__ + "img/watage_1.7a330ce7.png";